import { type CSSProperties } from 'react';
import { useNavigate } from 'react-router';
import { WorkingInterviewMutationMode } from '../../utils';
import { Colors } from '~/themes/colors';
import { Text } from '~/commonComponents';
import PlusIcon from '~/images/icons/PlusIcon';

interface IAddMoreWorkingInterviewButtonProps {
  jobPostingId: string;
}

const Style = {
  alignItems: 'center',
  backgroundColor: Colors.secondary_500,
  borderRadius: 25,
  boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
  display: 'inline-flex',
  flexShrink: 0,
  gap: 4,
  height: 30,
  justifyContent: 'center',
  padding: '8px 12px',
} as CSSProperties;

export const AddMoreWorkingInterviewButton = ({
  jobPostingId,
}: IAddMoreWorkingInterviewButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () =>
    navigate(`/permanent-jobs/postings/${jobPostingId}/working-interviews`, {
      state: {
        mode: WorkingInterviewMutationMode.Append,
      },
    });

  return (
    <button style={Style} onClick={handleClick}>
      <PlusIcon color={Colors.white} />
      <Text bold color={Colors.white} textAlign="center">
        Add Interviews
      </Text>
    </button>
  );
};
